import { useEffect, useState } from "react";
import { sanatiseStr } from "utils/sanatiseString";

export const useSubPageContent = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>();

  // Fetch Data from the page DOM + store in state
  useEffect(() => {
    const getData = () => {
      const jsonData =
        document.querySelector("#subpage-data script")?.textContent || "";
      setData(JSON.parse(sanatiseStr(jsonData)));
    };

    getData();

    return () => {
      setData({});
    };
  }, []);

  useEffect(() => {
    if(loading){
      data && setLoading(false);
    }
   
  }, [data]);

  // Destructure used content from JSON:
  const {
    MetaTitle = null,
    MetaDescription = null,
    HeroSectionTitle = null,
    HeroSectionSuperscript = null,
    HeroSectionImage1 = null,
    HeroSectionImage2 = null,
    HeroSectionImage3 = null,
    HeroSectionVideo = null,
    HeroSectionVideoAutoplay = null,
    HeroSectionVideoLoop = null,
    HeroSectionBlockOverlayColor = null,
    HeroSectionBlockOverlayColumn = null,
    TextEditor1 = null,
    TextEditor2 = null,
    ButtonSelection1 = null,
    ButtonSelection2 = null,
    QuickFactsLocationTitle = null,
    QuickFactsLocationContent = null,
    QuickFactsClientTitle = null,
    QuickFactsClientContent = null,
    QuickFactsProjectPartnersTitle = null,
    QuickFactsProjectPartnersContent = null,
    QuickFactsAureconRoleTitle = null,
    QuickFactsAureconRoleContent = null,
    QuickFactsAureconExpertiseTitle = null,
    QuickFactsAureconExpertiseContent = null,
    QuickFactsStatusTitle = null,
    QuickFactsStatusContent = null,
    QuickFactsFeaturesTitle = null,
    QuickFactsFeaturesContent = null,
    ContentBlocks = null,
    ImagePool = null,
    ShowImageCaptions = null,
    RelatedExpertise = null,
    RelatedMarkets = null,
    RelatedLocations = null,
    OtherTags = null,
    TagFilterByUrl = null,
    RelatedContent = null,
    RelatedContentHeading = null,
    ShowSocialSharing = null,
    ShowRelatedContent = null,
    ShowAbstracts = null,
    LargeContactCards = null,
    ButtonAlignment1 = null,
    ButtonAlignment2 = null,
    PublicationDate = null,
    ReadTime = null,
    ContentType = null,
    ShowPublicationDateReadTimeContentType = null,
    HeroSectionImageMobile = null,
    HeroSectionVideoMobile = null,
    Authors = null,
    ContactLinkPool = null,
    ContactUsTitle = null,
    ContactUsDescription = null,
    ShowDownloadIcon = null,
    ShowQuickFactsSidebar = null
  } = data || {};

  /**
   * Build the heroPanels data
   * - filter out nulls
   * - if the first item is a video, swap it with the first image
   */
  const heroPanels = [
    HeroSectionVideo,
    HeroSectionImage1,
    HeroSectionImage2,
    HeroSectionImage3,
  ].filter(Boolean);
  if (heroPanels[0]?.Extension === "mp4") heroPanels.splice(1, 1);

  return {
    loading,

    MetaTitle,
    MetaDescription,
    HeroSectionTitle,
    HeroSectionSuperscript,
    HeroSectionImage1,
    HeroSectionImage2,
    HeroSectionImage3,
    HeroSectionVideo,
    HeroSectionVideoAutoplay,
    HeroSectionVideoLoop,
    HeroSectionBlockOverlayColor,
    HeroSectionBlockOverlayColumn,
    TextEditor1,
    TextEditor2,
    ButtonSelection1,
    ButtonSelection2,
    ButtonAlignment1,
    ButtonAlignment2,

    QuickFactsLocationTitle,
    QuickFactsLocationContent,
    QuickFactsClientTitle,
    QuickFactsClientContent,
    QuickFactsProjectPartnersTitle,
    QuickFactsProjectPartnersContent,
    QuickFactsAureconRoleTitle,
    QuickFactsAureconRoleContent,
    QuickFactsAureconExpertiseTitle,
    QuickFactsAureconExpertiseContent,
    QuickFactsStatusTitle,
    QuickFactsStatusContent,
    QuickFactsFeaturesTitle,
    QuickFactsFeaturesContent,

    ContentBlocks,
    ImagePool,
    ShowImageCaptions,
    Tags: { RelatedExpertise, RelatedMarkets, RelatedLocations, OtherTags },
    TagFilterByUrl,
    RelatedContent,
    RelatedContentHeading,
    ShowSocialSharing,
    ShowRelatedContent,
    ShowAbstracts,

    heroPanels,
    LargeContactCards,
    PublicationDate,
    ReadTime,
    ContentType,
    ShowPublicationDateReadTimeContentType,
    HeroSectionImageMobile,
    HeroSectionVideoMobile,
    Authors,

    ContactLinkPool,
    ContactUsTitle,
    ContactUsDescription,

    ShowDownloadIcon,
    ShowQuickFactsSidebar
  };
};
